export default __webpack_public_path__ + "static/media/vaxwerks_card_tstanley.4553df96.pdf";